/**
 * 获取url的pathname
 * @param urlString url
 * @returns pathname
 */
export const getUrlPathname = (urlString) => {
    const regex = /^https?:\/\/[^\/]+(\/[^?#]*)/;
    const matches = urlString.match(regex);
    const pathname = matches && matches[1] ? matches[1] : 'No pathname found';
    return pathname;
};
